module.exports = __webpack_public_path__ + "static/img/share-wechat.13aaca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/share-wechat.png
// module id = Gr+c
// module chunks = 0